/**
 * Insert the provided separator between all pairs of values
 * in the array.
 * @param {Array} values
 * @param {*} separator
 * @returns {Array}
 */
export default function separateArray(values, separator) {
    return values.reduce((result, node, index, original) => (index < original.length - 1
        ? result.concat(node, separator)
        : result.concat(node)), []);
}
